// @flow

import { type ActionType, createActions, handleActions } from 'redux-actions'

export type PopupState = {
  +top: number,
  +left: number,
  +visible: boolean
}

export const popupActions = createActions({
  POPUP: {
    POSITION: {
      SET: (top: number, left: number) => ({ top, left }),
      /**
       * This action does not have a reducer, it is instead used as a
       * mid-step to be resolved in a saga (as opposed to directly getting the
       * position from the element, which would not be side-effect free,
       * since these positions depend on the scroll position of the reader).
       * @param annotatedElement
       * @return {Element}
       */
      TAKE_FROM: (annotatedElement: Element) => annotatedElement
    },
    SHOW: () => ({ visibility: true }),
    HIDE: () => ({ visibility: false })
  }
})

export const popupReducer: (
  PopupState,
  ActionType<typeof popupActions>
) => PopupState = handleActions(
  {
    POPUP: {
      POSITION: {
        SET: (state, action) => ({
          ...state,
          left: action.payload.left,
          top: action.payload.top
        })
      },
      SHOW: (state, { payload }) => ({
        ...state,
        visible: payload.visibility
      }),
      HIDE: (state, { payload }) => ({
        ...state,
        visible: payload.visibility
      })
    }
  },
  {
    left: window.innerWidth / 2 + window.pageXOffset,
    top: window.innerHeight / 2 + window.pageYOffset,
    visible: false
  }
)
